import { GetBrokersParams, brokersService } from '@/services';
import { useQuery } from '@tanstack/react-query';

export function useBrokers(
  params: GetBrokersParams = {},
  options: { enabled?: boolean } = {}
) {
  return useQuery({
    enabled: options.enabled ?? true,
    queryKey: ['brokers', params],
    queryFn: async () => {
      const response = await brokersService.listBrokers(params);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar corretores');
      }
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });
}
